import React from "react";
import Typical from 'react-typical';

import NavBar from "../../components/navbar/navbar.component";
import linkedinIcon from '../../assets/icons/linkedin.png';
import githubIcon from '../../assets/icons/github.png';
import resumeIcon from '../../assets/icons/resume.png';
import selfPortrait from '../../assets/icons/self.jpg';
import './homepage.styles.scss';


const introductions = ["full-stack developer 💻", 1000, "student 🏫", 1000, "software engineer", 1000];

const HomePage = () => (
  <div>
    <NavBar height={window.innerHeight} />
    <div className='homepage-header center'>
      <h3 id='name-top'>Hi! My name is</h3>
      <h1>Kwan Yoon</h1>
      <h3 id='name-bottom'>I am a: <Typical loop={Infinity} wrapper='b' steps={introductions} /></h3>
      <hr />
      <h3>2B Computer Science | University of Waterloo</h3>

      <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/kwan-yoon/">
        <img alt='linkedinIcon' src={linkedinIcon} className='header-icon icon-animate' />
      </a>
      <a target="_blank" rel="noopener noreferrer" href="https://github.com/KwanYoon">
        <img alt='githubIcon' src={githubIcon} className='header-icon icon-animate' />
      </a>
      <a target="_blank" rel="noopener noreferrer" href="https://imgur.com/a/BgsT2NK">
      <img alt='resumeIcon' src={resumeIcon} className='header-icon icon-animate' />
      </a>
    </div>

    <div className='section'>
      <p className='title center'>Profile</p>
      <hr />
      <div>
        <img alt="selfPortrait" src={selfPortrait} className='self-portrait' />
        <div id='aboutme'>
          <p className='sub-title'>About Me</p>
          <p className="content">
              I am a second year Computer Science student at the University of Waterloo. I love programming and working on
              projects. In this portfolio site, you will see the projects I've worked on and the skills I've developed while 
              working on them. I always try my best to put out high quality work, and love collaborating with others!
          </p>
        </div>
      </div>
      
      <div>
        <p className='sub-title'>Additional Details</p>
        <p className="content">
          <b>Age: </b>19
          <br /><b>Languages: </b>English, Korean
          <br /><b>Education: </b>Candidate for bachelors degree of computer sciences at the University of Waterloo
          <br /><b>GPA: </b>Major GPA: 93.5% | Cumulative GPA: 92.67%
          <br /><b>Awards: </b>One of 200 recipients of Faculty of Mathematics Scholarship ($10,000), 
          recipient of President’s Scholarship of Distinction ($2,000), recipient of Research Award ($3,000)
        </p>
      </div>

      <hr className='wide' />
    </div>
  </div>
)

export default HomePage;
